import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, type EdgeProps } from '@xyflow/react';
import { IconButton } from '@mui/joy';
import { X as CloseIcon } from '@phosphor-icons/react';

interface DeletableEdgeData {
  onDelete?: (edgeId: string) => void;
}

export default function DeletableEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const edgeData = data as unknown as DeletableEdgeData;

  const onEdgeClick = () => {
    if (edgeData?.onDelete) {
      edgeData.onDelete(id);
    }
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: 'all',
          }}
          className="nodrag nopan"
        >
          <IconButton
            size="sm"
            color="danger"
            variant="solid"
            onClick={onEdgeClick}
            sx={{
              minWidth: 24,
              minHeight: 24,
              padding: '2px',
              borderRadius: '50%',
            }}
          >
            <CloseIcon size={14} />
          </IconButton>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
